import { create } from 'zustand';
import type { Vector3Tuple } from 'three';
import type { SceneName } from '@/types';

export type QualityTier = 'cinematic' | 'balanced' | 'lite';

interface ViewportState {
  readonly scene: SceneName;
  readonly cameraTarget: Vector3Tuple;
  readonly timeCursorMs: number;
  readonly isPlaying: boolean;
  readonly qualityTier: QualityTier;
  /** Whether the one-shot cinematic intro has finished (per page load). */
  readonly introComplete: boolean;

  setScene: (scene: SceneName) => void;
  setCameraTarget: (target: Vector3Tuple) => void;
  setTimeCursor: (ms: number) => void;
  setPlaying: (playing: boolean) => void;
  setQualityTier: (tier: QualityTier) => void;
  completeIntro: () => void;
}

export const useViewportStore = create<ViewportState>((set) => ({
  scene: 'globe',
  cameraTarget: [0, 0, 0],
  timeCursorMs: 0,
  isPlaying: true,
  qualityTier: 'balanced',
  introComplete: false,

  setScene: (scene) => set({ scene }),
  setCameraTarget: (cameraTarget) => set({ cameraTarget }),
  setTimeCursor: (timeCursorMs) => set({ timeCursorMs }),
  setPlaying: (isPlaying) => set({ isPlaying }),
  setQualityTier: (qualityTier) => set({ qualityTier }),
  completeIntro: () => set({ introComplete: true }),
}));
